import { STORY_FOREST_DISTRICTS } from '../StoryForestState.js';
import {
  InferenceHollowScene,
  type ReadingEvidenceRouteDefinition,
} from '../inference-hollow/InferenceHollowScene.js';
import {
  AUTHORS_CABIN_ASSETS,
  AUTHORS_CABIN_ASSET_LIST,
  canEnterAuthorsCabin,
  getMissingAuthorsCabinAssets,
} from './AuthorsCabinAssets.js';
import { AUTHORS_CABIN_PASSAGE } from './AuthorsCabinConfig.js';
import { canEnterGrammarGlade } from '../grammar-glade/GrammarGladeAssets.js';

export const AUTHORS_CABIN_SCENE_KEY = 'AuthorsCabin';

const AUTHORS_CABIN_ROUTE: ReadingEvidenceRouteDefinition = {
  sceneKey: AUTHORS_CABIN_SCENE_KEY,
  sceneTitle: "AUTHOR'S CABIN",
  district: STORY_FOREST_DISTRICTS.authorsCabin,
  previousScene: 'InferenceHollow',
  previousLabel: 'INFERENCE HOLLOW',
  nextDistrict: STORY_FOREST_DISTRICTS.grammarGlade,
  nextScene: 'GrammarGlade',
  nextLabel: 'GRAMMAR GLADE',
  nextUnavailableMessage: 'The glade path is unlocked. Grammar Glade is awaiting its production build.',
  claimPhaseLabel: "CHOOSE THE AUTHOR'S PURPOSE",
  evidencePhaseLabel: 'CONNECT TWO TEXT FEATURES',
  completionPageLabel: 'PURPOSE COMPLETE',
  config: AUTHORS_CABIN_PASSAGE,
  assets: {
    dormant: AUTHORS_CABIN_ASSETS.dormant,
    restored: AUTHORS_CABIN_ASSETS.restored,
    choice: AUTHORS_CABIN_ASSETS.authorTool,
  },
  assetList: AUTHORS_CABIN_ASSET_LIST,
  getMissing: getMissingAuthorsCabinAssets,
  canEnter: canEnterAuthorsCabin,
  canEnterNext: canEnterGrammarGlade,
};

export class AuthorsCabinScene extends InferenceHollowScene {
  static readonly requiredImageKeys = AUTHORS_CABIN_ASSET_LIST.map(asset => asset.key);
  constructor() { super(AUTHORS_CABIN_ROUTE); }
}
